import { Component } from '@angular/core';
import { SharedFunctionService } from '../../services/shared-func.service';

@Component({
    selector: 'unauthorized',
    templateUrl: 'unauthorized.component.html',
    styleUrls: ['unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent {

  // private location:Location
  constructor(private readonly location: Location,private readonly _sharedFuncService : SharedFunctionService ) {

  }

  public logout() {
    this._sharedFuncService.logout(window);
  }

}
